import styled from '@emotion/styled';
import { Link } from '@blueprint/ui';
import { css } from '@emotion/react';

export const StyledJumpLink = styled(Link)`
    ${Link};
    display: block;
    text-decoration: none;

    &:focus {
        display: block;
    }
`;

export const Text = styled('p')(
    ({ theme }) => css`
        margin: 0;
        line-height: ${theme.type.lineHeight};
        font-size: ${theme.type.body};
        color: ${theme.colors['text-body']};
    `
);
